import React, { Component } from 'react';
import './css/style.module.css';
import User from './User'
import ReservationModal from './ReservationModal'
import { FewSlotsThreshold, RegularSlotsThreshold, ManySlotsThreshold, ReserveScreenMessage } from '../config/config'

export class Reservation extends Component {
    static displayName = Reservation.name;

    constructor(props) {
        super(props);
        this.state = {
            schedule: [],
            timetable: [],
            loading: true,
            showAlert: false,
            currentDate: new Date(),
            progress: { "GinoStep1Count": 0, "GinoStep2Count": 0 }
        };
    }

    componentDidMount() {
        this.populateScheduleData(new Date());
    }

    childToParent = () => {
        window.location.reload(false);
    }

    printTime(slotno, datestring) {
        var dateinfo = new Date(datestring);
        return dateinfo.getHours() + ':' + dateinfo.getMinutes().toString().padStart(2, '0') + '～';
    }

    printTimeTableData(slotno, datestring, isvisible) {
        if (isvisible) {
            return (<th>{this.printTime(slotno, datestring)}</th>);
        }
        else {
            return ("");
        }
    }

    printDate(datestring, isholiday) {
        const dateinfo = new Date(datestring);
        const days = ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'];
        const month = dateinfo.getMonth() + 1; // Months are zero-indexed
        const date = dateinfo.getDate();
        const day = days[dateinfo.getDay()];

        return `${month}/${date}${day}`;
    }

    printAvailability(slotcount, slot, dateTime, isHoliday, slottime) {
        var userNumber = User.getNumber();
	var dateToPrint = this.printDate(dateTime, isHoliday);
	var timeToPrint = this.printTime(slot, slottime);
	    console.log(slottime);
	    console.log(timeToPrint);

        if (slotcount >= ManySlotsThreshold) {
            return <ReservationModal userNumber={userNumber} slot={slot} reservationdate={dateToPrint} reservationtime={timeToPrint} display="◎" iscancel="false" mode="btn-primary" childToParent={this.childToParent} />;
        }
        else if (slotcount >= RegularSlotsThreshold) {
            return <ReservationModal userNumber={userNumber} slot={slot} reservationdate={dateToPrint} reservationtime={timeToPrint} display="○" iscancel="false" mode="btn-primary" childToParent={this.childToParent} />;
        }
        else if (slotcount >= FewSlotsThreshold) {
            return <ReservationModal userNumber={userNumber} slot={slot} reservationdate={dateToPrint} reservationtime={timeToPrint} display="△" iscancel="false" mode="btn-primary" childToParent={this.childToParent} />;
        }
        else if (slotcount < 0) {
            return <ReservationModal userNumber={userNumber} slot={slot} reservationdate={dateToPrint} reservationtime={timeToPrint} display="予約" iscancel="true" mode="btn-warning" childToParent={this.childToParent} />;
        }
        else {
            return '―';
        }
    }

    printTableData(slotcount, slot, dateTime, isdisplay, isHoliday, slottime) {
        if (isdisplay) {
            return (<td class="align-middle">{this.printAvailability(slotcount, slot, dateTime, isHoliday, slottime)}</td>);
        }
        else {
            return ("");
        }
    }

    printDateWithHoliday(datedisp, isHoliday) {
        if (isHoliday) {
            return (<span style={{ color: 'red' }}>{datedisp}㊡</span>);
        }
        else {
            return (<span>{datedisp}</span>);
        }
    }

    renderCalendarTableDay(datedisp, scheduleDay, timetable) {
        return (<tr align="center">
            <th scope="row">{this.printDateWithHoliday(datedisp, scheduleDay.isHoliday)}</th>
            {this.printTableData(scheduleDay.remainingSlot1,  1,  scheduleDay.scheduleDate, scheduleDay.isSlot1Visible, timetable.slot1)}
            {this.printTableData(scheduleDay.remainingSlot2,  2,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot2)}
            {this.printTableData(scheduleDay.remainingSlot3,  3,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot3)}
            {this.printTableData(scheduleDay.remainingSlot4,  4,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot4)}
            {this.printTableData(scheduleDay.remainingSlot5,  5,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot5)}
            {this.printTableData(scheduleDay.remainingSlot6,  6,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot6)}
            {this.printTableData(scheduleDay.remainingSlot7,  7,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot7)}
            {this.printTableData(scheduleDay.remainingSlot8,  8,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot8)}
            {this.printTableData(scheduleDay.remainingSlot9,  9,  scheduleDay.scheduleDate, true, scheduleDay.isHoliday, timetable.slot9)}
            {this.printTableData(scheduleDay.remainingSlot10, 10, scheduleDay.scheduleDate, scheduleDay.isSlot10Visible, scheduleDay.isHoliday, timetable.slot10)}
            {this.printTableData(scheduleDay.remainingSlot11, 11, scheduleDay.scheduleDate, scheduleDay.maxVisibleSlot >= 11, scheduleDay.isHoliday, timetable.slot11)}
            {this.printTableData(scheduleDay.remainingSlot12, 12, scheduleDay.scheduleDate, scheduleDay.maxVisibleSlot >= 12, scheduleDay.isHoliday, timetable.slot12)}
            {this.printTableData(scheduleDay.remainingSlot13, 13, scheduleDay.scheduleDate, scheduleDay.maxVisibleSlot >= 13, scheduleDay.isHoliday, timetable.slot13)}
            {this.printTableData(scheduleDay.remainingSlot14, 14, scheduleDay.scheduleDate, scheduleDay.maxVisibleSlot >= 14, scheduleDay.isHoliday, timetable.slot14)}
        </tr>);
    }

    renderCalendarTable(schedule, timetable) {
        var datedisp1 = this.printDate(schedule.schedule1.scheduleDate, schedule.schedule1.isHoliday);
        var datedisp2 = this.printDate(schedule.schedule2.scheduleDate, schedule.schedule2.isHoliday);
        var datedisp3 = this.printDate(schedule.schedule3.scheduleDate, schedule.schedule3.isHoliday);
        var datedisp4 = this.printDate(schedule.schedule4.scheduleDate, schedule.schedule4.isHoliday);
        var datedisp5 = this.printDate(schedule.schedule5.scheduleDate, schedule.schedule5.isHoliday);
        var datedisp6 = this.printDate(schedule.schedule6.scheduleDate, schedule.schedule6.isHoliday);
        var datedisp7 = this.printDate(schedule.schedule7.scheduleDate, schedule.schedule7.isHoliday);

        return (
            <div class="table-responsive text-nowrap">
                <table class="table">
                    <thead>
                        <tr align="center" class="table-dark">
                            <th>日付</th>
                            {this.printTimeTableData('①', timetable.slot1, schedule.schedule1.isSlot1Visible)}
                            {this.printTimeTableData('②', timetable.slot2, true)}
                            {this.printTimeTableData('③', timetable.slot3, true)}
                            {this.printTimeTableData('④', timetable.slot4, true)}
                            {this.printTimeTableData('⑤', timetable.slot5, true)}
                            {this.printTimeTableData('⑥', timetable.slot6, true)}
                            {this.printTimeTableData('⑦', timetable.slot7, true)}
                            {this.printTimeTableData('⑧', timetable.slot8, true)}
                            {this.printTimeTableData('⑨', timetable.slot9, true)}
                            {this.printTimeTableData('⑩', timetable.slot10, schedule.schedule1.isSlot10Visible)}
                            {this.printTimeTableData('⑪', timetable.slot11, schedule.schedule1.maxVisibleSlot >= 11)}
                            {this.printTimeTableData('⑫', timetable.slot12, schedule.schedule1.maxVisibleSlot >= 12)}
                            {this.printTimeTableData('⑬', timetable.slot13, schedule.schedule1.maxVisibleSlot >= 13)}
                            {this.printTimeTableData('⑭', timetable.slot14, schedule.schedule1.maxVisibleSlot >= 14)}
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderCalendarTableDay(datedisp1, schedule.schedule1, timetable)}
                        {this.renderCalendarTableDay(datedisp2, schedule.schedule2, timetable)}
                        {this.renderCalendarTableDay(datedisp3, schedule.schedule3, timetable)}
                        {this.renderCalendarTableDay(datedisp4, schedule.schedule4, timetable)}
                        {this.renderCalendarTableDay(datedisp5, schedule.schedule5, timetable)}
                        {this.renderCalendarTableDay(datedisp6, schedule.schedule6, timetable)}
                        {this.renderCalendarTableDay(datedisp7, schedule.schedule7, timetable)}
                    </tbody>
                </table>
            </div>);
    }

    static renderPrevButton(obj, basedatestring) {
        let handlePrevClick = () => {
            var date = new Date(basedatestring);
            var prevDate = new Date(date.getFullYear(), date.getMonth());
            prevDate.setDate(date.getDate() - 7);
            obj.populateScheduleData(prevDate);
        };

        var date = new Date(basedatestring);
        date.setMilliseconds(0);
        date.setSeconds(0);

        var today = new Date();
        today.setMilliseconds(0);
        today.setSeconds(0);
        var date1 = date.getTime();
        var today1 = today.getTime();
        if (today1 <= date1) {
            return (<button className="btn btn-info" onClick={handlePrevClick}>前の週</button>);
        }
        return (<button className="btn btn-dark">前の週</button>);
    }

    static renderNextButton(obj, basedatestring) {
        let handleNextClick = () => {
            var date = new Date(basedatestring);
            var nextDate = new Date(date.getFullYear(), date.getMonth());
            nextDate.setDate(date.getDate() + 7);
            obj.populateScheduleData(nextDate);
        };

        return (
            <button className="btn btn-info" onClick={handleNextClick}>次の週</button>
        );
    }

    static renderKyoshu(displayNo, steplist, reservelist) {
        if (steplist && steplist.includes(displayNo)) {
            return (<button className="btn btn-primary btn-sm">{displayNo}</button>);
        }
        if (reservelist && reservelist.includes(displayNo)) {
            return (<button className="btn btn-warning btn-sm">{displayNo}</button>);
        }
        else {
            return (<button className="btn btn-light btn-sm">{displayNo}</button>);
        }
    }

    static renderKyoshuSet(stepcount, steplist, reservelist) {
        const rows = [];
        for (var i = 0; i < stepcount; i++) {
            rows.push(Reservation.renderKyoshu(i+1, steplist, reservelist));
        }
        return rows;
    }

    static renderProgress(progress) {
        return (
        <div>
            <h4>技能教習進捗</h4>
            <h6>１段階</h6>
            <div class="btn-group">
                {Reservation.renderKyoshuSet(progress.ginoStep1Count, progress.ginoStep1List, progress.ginoStep1ReserveList)}
            </div>
            <p />
            <h6>２段階</h6>
            <div class="btn-group">
                {Reservation.renderKyoshuSet(progress.ginoStep2Count, progress.ginoStep2List, progress.ginoStep2ReserveList)}
            </div>

            <p />
            <h4>学科教習進捗</h4>
            <h6>１段階</h6>
                <div class="btn-group">
                    {Reservation.renderKyoshu(1, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(2, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(3, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(4, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(5, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(6, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(7, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(8, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(9, progress.gakkaStep1List)}
                    {Reservation.renderKyoshu(10, progress.gakkaStep1List)}
            </div>
            <p />
            <h6>２段階</h6>
            <div class="btn-group">
                    {Reservation.renderKyoshu(1, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(2, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(3, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(4, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(5, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(6, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(7, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(8, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(9, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(10, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(11, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(12, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(13, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(14, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(15, progress.gakkaStep2List)}
                    {Reservation.renderKyoshu(16, progress.gakkaStep2List)}
            </div>
            <p />
            <button className="btn btn-primary btn-sm">済は青色</button>&nbsp;
            <button className="btn btn-warning btn-sm">予約は黄色</button>
        </div>);
    }

    render() {
        let contents = this.state.loading
            ? <p><em>読み込み中...</em></p>
            : this.renderCalendarTable(this.state.schedule, this.state.timetable);

        let progressContents = this.state.loading
            ? <p><em>読み込み中...</em></p>
            : Reservation.renderProgress(this.state.progress);

        let nameandnumber = this.state.loading ? "" : <h6>{this.state.progress.name}さん、ようこそ！(番号:{User.getNumber()})</h6>

        let prevbutton = Reservation.renderPrevButton(this, this.state.currentDate.toISOString());
        let nextbutton = Reservation.renderNextButton(this, this.state.currentDate.toISOString());

        return (
            <div>
                <table width="100%"><tr><td align="right">{nameandnumber}</td></tr></table> 
                <h3 id="tableLabel">予約情報</h3>
                {prevbutton}&nbsp;
                {nextbutton}
                <p />
                <table width="100%"><tr><td align="right">{ReserveScreenMessage}</td></tr></table> 
                {contents}
                <p />
                {progressContents}
            </div>
        );
    }

    async populateScheduleData(datetime) {
        var date = new Date(datetime.toDateString());
        //alert("pop " + date);
        const response = await fetch('schedule/listschedule?dateTime=' + date.toISOString() + '&userNumber=' + User.getNumber());
        const data = await response.json();
        const timetableresponse = await fetch('/schedule/timetable');
        const timetable = await timetableresponse.json();

        const userprogressresponse = await fetch('/user/getuserprogress?userNumber=' + User.getNumber());
        const userprogress = await userprogressresponse.json();
        this.setState({ schedule: data, timetable: timetable, loading: false, currentDate: datetime, progress: userprogress });
    }
}
